// Vue
import { Vue, Component, Prop, Inject } from "vue-property-decorator";

// Template
import template from "./template.vue";

// Base Module
import ModuleBase from "#/common/ModuleBase";

// Components
import ModuleWrapper from "#/components/module_wrapper/ModuleWrapper";
import { Observer } from "mobx-vue";
import { BodyBuilder } from "../../../common/interfaces/conversionworld/BodyBuilder";
import { reaction } from "mobx";
import { Headline } from "../../../components/headline/Headline";
import { Gallery } from "../../../components/gallery/Gallery";
import { ImageAspectRatio } from "../../../components/image_aspect_ratio/ImageAspectRatio";

@Observer
@Component({
  mixins: [template],
  components: {
    ModuleWrapper,
    Headline,
    Gallery,
    ImageAspectRatio,
  },
})
export class AbhProductsModule extends ModuleBase {
  public getBackgroundColorFromInstance(instance: object) {
    return "black";
  }
}
